/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails
 */
export interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails {
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails
     */
    status_set_date?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails
     */
    status_set_reason?: string;
}

/**
 * Check if a given object implements the FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails interface.
 */
export function instanceOfFindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsFromJSON(json: any): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails {
    return FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsFromJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status_set_date': !exists(json, 'status_set_date') ? undefined : json['status_set_date'],
        'status_set_reason': !exists(json, 'status_set_reason') ? undefined : json['status_set_reason'],
    };
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsToJSON(value?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status_set_date': value.status_set_date,
        'status_set_reason': value.status_set_reason,
    };
}

